import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';

@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.scss'],
})
export class ImportModalComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef | null =
    null;

  acceptedFileTypes: string[] = ['XLS', 'XLSX', 'CSV'];
  modalTitle: string = 'Importação de Veículos';
  fileNames: string[] = [];
  selectedFile: File | null = null;
  maxFileSize: number = 25 * 1024 * 1024;
  file: File | null = null;
  filesInfo: any;
  fileSize: string = '';
  constructor(
    private toastService: ToastService,
    private dialogRef: MatDialogRef<ImportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
  ) {}

  ngOnInit(): void {
    if (this.uploadData && this.uploadData.acceptedFileTypes) {
      this.acceptedFileTypes = this.uploadData.acceptedFileTypes;
    }

    if (this.uploadData && this.uploadData.modalTitle) {
      this.modalTitle = this.uploadData.modalTitle;
    }
  }

  onSubmit() {
    const data = {
      ...this.filesInfo,
    };
    this.dialogRef.close(data);
  }

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file.size > this.maxFileSize) {
      const maxSize = this.maxFileSize / 1024 / 1024;
      return this.toastService.showError(
        `O tamanho do arquivo selecionado é maior do que o permitido. Selecione arquivos de até 25MB de tamanho. .`,
      );
    }

    this.file = file;
    this.selectedFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File: any = reader.result;
      const fileInfos: {
        name: string;
        size: number;
        type: string;
        base64: string;
        file: any;
      }[] = [];

      fileInfos.push({
        name: file.name,
        size: file.size,
        type: file.type,
        base64: base64File,
        file: file,
      });
      this.filesInfo = {
        name: file.name,
        size: file.size,
        type: file.type,
        base64: base64File,
        file: file,
      };
      this.fileSize = `${(file.size / 1024).toFixed(2)} KB`;
      this.fileNames = [file.name];
    };
  }
  triggerFileInputClick(): void {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    }
  }
  back() {
    this.dialogRef.close();
  }
  removeFile(): void {
    this.filesInfo = null;
    this.fileSize = '';
  }

  getResponsiveFileName(nome: string): string {
    const largura = window.innerWidth;

    let limiteCaracteres = 100;

    if (largura <= 768) {
      limiteCaracteres = 25;
    }
    if (largura <= 480) {
      limiteCaracteres = 15;
    }

    return nome.length > limiteCaracteres
      ? nome.substring(0, limiteCaracteres) + '...'
      : nome;
  }
}
